import Cookie from "js-cookie";
import SSRCookie from "cookie";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
export const AUTH_CRED = "AUTH_CUSTOMER";
export const DETAILS = "Details";
export const CUSTOMERID = "customerUuid";
export const QUOTE_SESSION = "QUOTE";

export function setAuthCredentials(
  token?: string,
  refreshToken?: string,
  customerUuid?: string,
  userUuid?: string,
  details?: any,
  countryCode?: string,
  isInternational?: boolean
) {
  // const cookiesConsent = Cookies.get('cookiesConsent');
  // if (cookiesConsent !== 'isAccepted') return;

  const expiresDaysString =
    process.env.REACT_APP_AUTH_COOKIE_EXPIRATION_TIME ?? "";
  const authData = { token, refreshToken, details, customerUuid, userUuid, countryCode, isInternational };
  setCookieWithExpiration(
    AUTH_CRED,
    JSON.stringify(authData),
    expiresDaysString
  );
  // Cookies.set(AUTH_CRED, JSON.stringify(authData)); // Set cookie with expiration time
}

export const setQuoteCookies = (quoteId: string) => {
  const cookiesConsent = Cookies.get("cookiesConsent");
  if (cookiesConsent !== "isAccepted") return;

  const expiresDaysString =
    process.env.REACT_APP_QUOTE_COOKIE_EXPIRATION_TIME ?? "";
  const sessionData1 = quoteId;
  setCookieWithExpiration(
    QUOTE_SESSION,
    JSON.stringify(sessionData1),
    expiresDaysString
  );
  // Cookies.set(QUOTE_SESSION, JSON.stringify(sessionData1));
};

export function getAuthCredentials(context?: any): {
  details: any | null;
  customerUuid: any | null;
  quoteId: any | null;
  token: any | null;
  refreshToken: any | null;
  userUuid: any | null;
  countryCode: string;
  isInternational: boolean;
} {
  let authCred;
  let quote;
  if (context) {
    const cookies = parseSSRCookie(context);
    authCred = cookies[AUTH_CRED];
    quote = cookies[QUOTE_SESSION];
  } else {
    authCred = Cookie.get(AUTH_CRED);
    quote = Cookie.get(QUOTE_SESSION);
  }  
  return {
    details: authCred ? JSON.parse(authCred).details : null,
    customerUuid: authCred ? JSON.parse(authCred).customerUuid : null,
    quoteId: quote ? JSON.parse(quote) : null,
    token: authCred ? JSON.parse(authCred).token : null,
    refreshToken: authCred ? JSON.parse(authCred).refreshToken : null,
    userUuid: authCred ? JSON.parse(authCred).userUuid : null,
    countryCode: authCred ? JSON.parse(authCred).countryCode : '+44',
    isInternational: authCred ? JSON.parse(authCred).isInternational : false
  };
}

export function parseSSRCookie(context: any) {
  return SSRCookie.parse(context.req.headers.cookie ?? "");
}

export function isAuthenticated(_cookies: any) {
  return (
    !!_cookies[DETAILS] && !!_cookies[CUSTOMERID] && !!_cookies[QUOTE_SESSION]
  );
}

export const deleteCookie = (name: any) => {
  Cookies.remove(name);
};

// Function to parse the expiration string and calculate the expiration date
const parseExpirationTime = (expirationString: string): number => {
  const unit = expirationString.slice(-1); // "d", "h", or "m"
  const value = parseInt(expirationString.slice(0, -1), 10);
  switch (unit) {
    case "d":
      return value * 24 * 60 * 60 * 1000; // Days in milliseconds
    case "h":
      return value * 60 * 60 * 1000; // Hours in milliseconds
    case "m":
      return value * 60 * 1000; // Minutes in milliseconds
    default:
      return 0; // No expiration
  }
};

// Function to set a cookie with an expiration date
export const setCookieWithExpiration = (
  name: any,
  value: any,
  expirationString: any
) => {
  const milliseconds = parseExpirationTime(expirationString);
  const expirationDate = new Date(Date.now() + milliseconds);
  // Store expiration time in localStorage
  Cookie.set(name, value, { expires: expirationDate });
  localStorage.setItem(`${name}_expires`, expirationDate.getTime().toString());
};

export const checkCookieExpiration = (name: string, navigate: any) => {
  const expirationTimestamp = localStorage.getItem(`${name}_expires`);
  if (expirationTimestamp) {
    const currentTimestamp = Date.now();
    const expired = currentTimestamp > parseInt(expirationTimestamp, 10);
    if (expired) {
      // Cookie has expired
      const id = localStorage.getItem("productUuid");
      deleteCookie(QUOTE_SESSION);
      deleteCookie(AUTH_CRED);
      // toast.error("Something went wrong");
      localStorage.clear();
      if (id != null) {
        navigate(`/product/?id=${id}`);
      } else {
        navigate("/not-found");
      }
    }
  }
};

let sessionTimeout: NodeJS.Timeout;
const TIME: any = parseExpirationTime(
  process.env.REACT_APP_QUOTE_COOKIE_EXPIRATION_TIME ?? ""
);
const startSessionTimeout = (): void => {
  // Clear any existing timers
  clearTimeout(sessionTimeout);

  sessionTimeout = setTimeout(() => {
    const id = localStorage.getItem("productUuid");
    deleteCookie(QUOTE_SESSION);
    deleteCookie(AUTH_CRED);

    // toast.error("Something went wrong");
    localStorage.clear();
    if (id != null) {
      window.location.href = `/product/?id=${id}`;
    } else {
      window.location.href = "/not-found";
    }
  }, TIME);
};

// Function to handle user activity and reset the timeout
const resetSessionTimeout = (): void => {
  startSessionTimeout();
};

// Attach event listeners for user activity
export const initializeSessionTimeout = (): void => {
  if (typeof window !== "undefined") {
    window.onload = startSessionTimeout; // Start timer when the page loads
    window.onmousemove = resetSessionTimeout; // Reset on mouse move
    window.onkeypress = resetSessionTimeout; // Reset on key press
  }
};

export const setIdvBypass = (storeDetails: any) => {
  localStorage.setItem('disableIDV', storeDetails.disableIDV ? storeDetails.disableIDV : false);
  localStorage.setItem('bypassIDV', storeDetails.bypassIDV ? storeDetails.bypassIDV : false);
  if (storeDetails.bypassIDV) {
    localStorage.setItem('maximumOrderValue', storeDetails.maximumOrderValue);
  } else {
    localStorage.removeItem('maximumOrderValue');
  } 

  // Cookies.set('bypassIDV', storeDetails.bypassIDV ? storeDetails.bypassIDV : false);
  // if (storeDetails.bypassIDV) {
  //   Cookies.set('maximumOrderValue', storeDetails.maximumOrderValue);
  // }
}

export const getIdvBypass = () => {
  const disableIDV = localStorage.getItem('disableIDV');
  const bypassIDV = localStorage.getItem('bypassIDV');
  const maximumOrderValue = localStorage.getItem('maximumOrderValue');

  // const bypassIDV = Cookies.get('bypassIDV');
  // const maximumOrderValue = Cookies.get('maximumOrderValue');

  return {disableIDV: disableIDV === 'true', bypassIDV: bypassIDV === 'true', maximumOrderValue};
}